import { showPopup } from "../redux/action";
import { useDispatch } from "react-redux";
import popupActions from "../../../redux/actions/popupActions";

const ToolsList = ({
  tools,
  description,
  service,
  analytics,
  isAddedImage,
}: {
  tools: string[];
  description: string[];
  service: string;
  analytics: {sendClickTool: Function};
  isAddedImage: boolean;
}) => {
  const dispatch = useDispatch();
  const { setSelectedTool } = popupActions();
  const toolsLits = tools.map((tool: string, index: number) => {
    return (
      <li className="service__tool" key={`tool_${index}`}>
        <a
          title={`${description[index]}`}
          href={`/image-${tool}`}
          onClick={(e) => { 
            analytics.sendClickTool(tool); 
            if (isAddedImage) {
              e.preventDefault();
              setSelectedTool(tool);
              dispatch(showPopup("redirect_popup"))
            }
          }}
        >
          <i className={`icon__${tool}${service === tool ? "_active" : ""}`} />
        </a>
      </li>
    );
  });

  return <>{toolsLits}</>
};

export default ToolsList;
